export default __webpack_public_path__ + "static/media/(84).037865e1.jpg";